export const PERSONAL_LOANS_CALCULATOR = 'personalLoansCalculator';

export const PERSONAL_LOANS_CALCULATOR_SET_VALUE = `${PERSONAL_LOANS_CALCULATOR}/setValue`;
export const PERSONAL_LOANS_CALCULATOR_SET_VALID = `${PERSONAL_LOANS_CALCULATOR}/setValid`;

export const AMOUNT_BORROWED_SET_VALUE = `${PERSONAL_LOANS_CALCULATOR_SET_VALUE}/amountBorrowed`;
export const AMOUNT_BORROWED_SET_VALID = `${PERSONAL_LOANS_CALCULATOR_SET_VALID}/amountBorrowed`;
export const CUSTOM_AMOUNT_BORROWED_SET_VALUE = `${PERSONAL_LOANS_CALCULATOR_SET_VALUE}/customAmountBorrowed`;
export const CUSTOM_AMOUNT_BORROWED_SET_VALID = `${PERSONAL_LOANS_CALCULATOR_SET_VALID}/customAmountBorrowed`;
export const REPAYMENT_DURATION_SET_VALUE = `${PERSONAL_LOANS_CALCULATOR_SET_VALUE}/repaymentDuration`;
export const REPAYMENT_DURATION_SET_VALID = `${PERSONAL_LOANS_CALCULATOR_SET_VALID}/repaymentDuration`;
export const CUSTOM_REPAYMENT_DURATION_SET_VALUE = `${PERSONAL_LOANS_CALCULATOR_SET_VALUE}/customRepaymentDuration`;
export const CUSTOM_REPAYMENT_DURATION_SET_VALID = `${PERSONAL_LOANS_CALCULATOR_SET_VALID}/customRepaymentDuration`;

export const REQUEST_LOAN_RESULTS = `${PERSONAL_LOANS_CALCULATOR}/requestResults`;
export const CALCULATE_LOAN_RESULTS = `${PERSONAL_LOANS_CALCULATOR}/calculateResults`;
export const CALCULATE_LOAN_RESULTS_SUCCESS = `${CALCULATE_LOAN_RESULTS}/success`;
export const CALCULATE_LOAN_RESULTS_FAILURE = `${CALCULATE_LOAN_RESULTS}/failure`;

export const RESET_FORM = `${PERSONAL_LOANS_CALCULATOR}/reset`;

export const resetForm = () => ({ type: RESET_FORM });
export const requestLoanResults = () => ({ type: REQUEST_LOAN_RESULTS });
export const calculateLoanResults = () => ({ type: CALCULATE_LOAN_RESULTS });
export const calculateLoanResultsSuccess = (value) => ({ type: CALCULATE_LOAN_RESULTS_SUCCESS, value });
export const calculateLoanResultsFailure = (error) => ({ type: CALCULATE_LOAN_RESULTS_FAILURE, error });

export const setAmountBorrowedValue = (value) => ({ type: AMOUNT_BORROWED_SET_VALUE, value });
export const setAmountBorrowedValid = (error) => ({ type: AMOUNT_BORROWED_SET_VALID, error });
export const setCustomAmountBorrowedValue = (value) => ({ type: CUSTOM_AMOUNT_BORROWED_SET_VALUE, value });
export const setCustomAmountBorrowedValid = (error) => ({ type: CUSTOM_AMOUNT_BORROWED_SET_VALID, error });
export const setRepaymentDurationValue = (value) => ({ type: REPAYMENT_DURATION_SET_VALUE, value });
export const setRepaymentDurationValid = (error) => ({ type: REPAYMENT_DURATION_SET_VALID, error });
export const setCustomRepaymentDurationValue = (value) => ({ type: CUSTOM_REPAYMENT_DURATION_SET_VALUE, value });
export const setCustomRepaymentDurationValid = (error) => ({ type: CUSTOM_REPAYMENT_DURATION_SET_VALID, error });
